module.exports = __webpack_public_path__ + "static/logo-dbb66ae34be79897aab24525ff76459c.png";